import client from '@/api/client.js';
import i18n from '@/plugins/i18n.js';
import store from "@/store";
export default {
    methods: {
        async getCounterListFromFilter(filter, cancelationToken) {
            var meta = { clientApiMethod: 'getCounterListFromFilter', input: { filter: filter } }
            var response = await client().get(store.state.apiRouteRoot + "Counter/Filtered", { params: filter, signal: cancelationToken, meta: meta })
            return response?.data;
        },
        async getCounterById(id) {
            var meta = { clientApiMethod: 'getCounterById', input: { id: id } }
            var response = await client().get(store.state.apiRouteRoot + "Counter/" + id, { meta: meta })
            return response?.data;
        },
        async createCounter(newCounter) {
            var meta = {
                clientApiMethod: 'createCounter',
                input: { newCounter },
                successText: i18n.t("servicesystem.responses.created_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().post(store.state.apiRouteRoot + 'Counter', newCounter, { meta: meta })
            return response?.data;
        },
        async updateCounter(updatedCounter) {
            var meta = {
                clientApiMethod: 'updateCounter',
                input: { updatedCounter },
                successText: i18n.t("servicesystem.responses.changed_object", { okey: i18n.t("servicesystem.common_objects.counter.counter") })
            }
            var response = await client().patch(store.state.apiRouteRoot + 'Counter', updatedCounter, { meta: meta })
            return response?.data;
        },

        async getCountersByMachineId(machineId) {
            var meta = { clientApiMethod: 'getCountersByMachineId', input: { machineId: machineId } }
            var response = await client().get(`${store.state.apiRouteRoot}Counter/Machine/${machineId}`, { meta: meta })
            return response?.data;
        },

        async getCountersWithHistoryByMachineId(machineId) {
            var meta = { clientApiMethod: 'getCountersWithHistoryByMachineId', input: { machineId: machineId } }
            var response = await client().get(`${store.state.apiRouteRoot}Counter/Machine/${machineId}/History`, { meta: meta })
            return response?.data;
        },

        async setMachineCounter(dto) {
            var meta = { clientApiMethod: 'setMachineCounter', input: { dto: dto } }
            var response = await client().put(store.state.apiRouteRoot + "Counter/Machine", dto, { meta: meta })
            return response?.data;
        },

        async deleteHistoricMachineCounter(dto) {
            var meta = { clientApiMethod: 'deleteHistoricMachineCounter', input: { dto: dto } }
            var response = await client().delete(store.state.apiRouteRoot + "Counter/Machine", { params: dto, meta: meta })
            return response?.data;
        },
    }
}